module.exports = __webpack_public_path__ + "static/media/NotoSansArabic-Bold.8ec4541e.ttf";